import { render, staticRenderFns } from "./workOrderPieChart.vue?vue&type=template&id=2230fd0f"
import script from "./workOrderPieChart.vue?vue&type=script&lang=js"
export * from "./workOrderPieChart.vue?vue&type=script&lang=js"
import style0 from "./workOrderPieChart.vue?vue&type=style&index=0&id=2230fd0f&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports